import { render, staticRenderFns } from "./ProdutosOpcionaisForm.vue?vue&type=template&id=0861d13f&scoped=true"
import script from "./ProdutosOpcionaisForm.vue?vue&type=script&lang=js"
export * from "./ProdutosOpcionaisForm.vue?vue&type=script&lang=js"
import style0 from "./ProdutosOpcionaisForm.vue?vue&type=style&index=0&id=0861d13f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0861d13f",
  null
  
)

export default component.exports